var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineEdit16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 10.6667L2.13373 10.1363L1.91406 10.356V10.6667H2.66406ZM11.3307 2L11.8611 1.46967C11.5682 1.17678 11.0933 1.17678 10.8004 1.46967L11.3307 2ZM13.9974 4.66667L14.5277 5.197C14.8206 4.9041 14.8206 4.42923 14.5277 4.13634L13.9974 4.66667ZM5.33073 13.3333V14.0833H5.64139L5.86106 13.8637L5.33073 13.3333ZM2.66406 13.3333H1.91406C1.91406 13.7475 2.24985 14.0833 2.66406 14.0833V13.3333ZM3.19439 11.197L11.8611 2.53033L10.8004 1.46967L2.13373 10.1363L3.19439 11.197ZM10.8004 2.53033L13.4671 5.197L14.5277 4.13634L11.8611 1.46967L10.8004 2.53033ZM13.4671 4.13634L4.8004 12.803L5.86106 13.8637L14.5277 5.197L13.4671 4.13634ZM5.33073 12.5833H2.66406V14.0833H5.33073V12.5833ZM3.41406 13.3333V10.6667H1.91406V13.3333H3.41406ZM8.8004 4.53033L11.4671 7.197L12.5277 6.13634L9.86106 3.46967L8.8004 4.53033Z",
    fill: "#1778E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineEdit16);
export default __webpack_public_path__ + "static/media/outline-edit-16.1d3ee200.svg";
export { ForwardRef as ReactComponent };